module.exports = __webpack_public_path__ + "img/上海煜豆信息科技有限公司 SHANGHAI YUDOU INFORMATION TECHNOLOGY CO., LTD-1.e6ef3657.png";